const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEconomic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_6615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.939 30.7642C44.885 29.9346 42.0363 28.978 39.5517 29.2869C36.4913 29.6679 34.9125 32.0044 34.9464 33.9938C34.9802 36.2541 36.5548 37.9007 40.3347 39.4584C44.9612 41.3674 46.921 43.5092 46.3411 46.5907C45.9813 48.5039 44.3178 50.4637 40.6734 50.6372C37.9051 50.7684 35.0522 49.4605 33.5707 48.2457",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 1.69312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2119 50.9756V55.7248",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 1.69312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2119 28.9865V24.2754",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 1.69312,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 1.8457C61.0714 1.8457 78.1531 18.9275 78.1532 39.999C78.1532 61.0706 61.0714 78.1523 39.9999 78.1523C18.9284 78.1523 1.84656 61.0705 1.84656 39.999C1.84662 18.9276 18.9284 1.84577 39.9999 1.8457Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 15.792C53.3687 15.792 64.2069 26.6294 64.207 39.998C64.207 53.3668 53.3688 64.2051 40 64.2051C26.6313 64.2049 15.7939 53.3667 15.7939 39.998C15.7941 26.6295 26.6314 15.7922 40 15.792Z",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 0.845703V14.7928",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3123 58.3105L67.0817 68.0799",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7939 39.999H0.846771",
    stroke: "#2B2B2B",
    style: {
      stroke: "#2B2B2B",
      stroke: "color(display-p3 0.1686 0.1686 0.1686)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_6615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEconomic);
export default __webpack_public_path__ + "static/media/icon-economic.d520bc779e2c45b9a0d22be63e0d4707.svg";
export { ForwardRef as ReactComponent };